import { useMutation, useQuery } from "@tanstack/react-query";
import { WalkthroughModel } from "./types";
import queryClient from "../../../query-client";
import { useGet, usePut } from "../../../api-service";

export const useGetUserWalkthroughTrack = () => {
  const { get } = useGet();
  var url = "/api/user-walkthrough";

  return useQuery<WalkthroughModel>({
    queryFn: () => get<WalkthroughModel>(url),
    queryKey: ["walkthrough-tracker"],
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 0,
  });
};

//add another type of val to the function if module not included here:
export const useUpdateUserWalkthrough = (
  val:
    | "Home"
    | "PatientRegistration"
    | "HealthScreening"
    | "HealthScreeningForms"
    | "Consultation"
    | "ConsultationForms"
    | "Facilities"
    | "FacilityUsers"
    | "FollowUpMedicine"
    | "GroupAdmins"
    | "LandingPage"
    | "Transmittals"
    | "ManageUserAccess"
    | "Products"
    | "Reports"
    | "Clients"
    | "BizboxUsers"
    | "Notifications"
    | "ManageAccessability"
    | "Dashboard"
    | "Home"
    | "Sessions"
    | "SecuritySettings"
    | "FacilitiesAdmin"
    | "ProductsAdmin"
    | "FacilityUsersAdmin"
) => {
  const { put } = usePut();

  type WalkthroughPayload =
    | { isPRPageFinished: true }
    | { isHSPageFinished: true }
    | { isHSFormsFinished: true }
    | { isConsPageFinished: true }
    | { isConsFormsFinished: true }
    | { isFacilitiesFinished: true }
    | { isFacilityUsersFinished: true }
    | { isFollowUpMedicineFinished: true }
    | { isGroupAdminsFinished: true }
    | { isLandingPageFinished: true }
    | { isTransmittalFinished: true }
    | { isManageUserAccessFinished: true }
    | { isProductsFinished: true }
    | { isReportsPageFinished: true }
    | { isClientsFinished: true }
    | { isBizboxUsersFinished: true }
    | { isNotificationFinished: true }
    | { isManageAccessabilityFinished: true }
    | { isDashBoardFinished: true }
    | { isHomeFinished: true }
    | { isSessionFinished: true }
    | { isSecuritySettingsFinished: true };

  const getPayload = (): WalkthroughPayload => {
    switch (val) {
      case "PatientRegistration":
        return { isPRPageFinished: true };
      case "HealthScreening":
        return { isHSPageFinished: true };
      case "HealthScreeningForms":
        return { isHSFormsFinished: true };
      case "Consultation":
        return { isConsPageFinished: true };
      case "ConsultationForms":
        return { isConsFormsFinished: true };
      case "Facilities":
        return { isFacilitiesFinished: true };
      case "FacilityUsers":
        return { isFacilityUsersFinished: true };
      case "FollowUpMedicine":
        return { isFollowUpMedicineFinished: true };
      case "GroupAdmins":
        return { isGroupAdminsFinished: true };
      case "LandingPage":
        return { isLandingPageFinished: true };
      case "Transmittals":
        return { isTransmittalFinished: true };
      case "ManageUserAccess":
        return { isManageUserAccessFinished: true };
      case "Products":
        return { isProductsFinished: true };
      case "Reports":
        return { isReportsPageFinished: true };
      case "Clients":
        return { isClientsFinished: true };
      case "BizboxUsers":
        return { isBizboxUsersFinished: true };
      case "Notifications":
        return { isNotificationFinished: true };
      case "ManageAccessability":
        return { isManageAccessabilityFinished: true };
      case "Dashboard":
        return { isDashBoardFinished: true };
      case "Home":
        return { isHomeFinished: true };
      case "Sessions":
        return { isSessionFinished: true };
      case "SecuritySettings":
        return { isSecuritySettingsFinished: true };
      case "FacilitiesAdmin":
        return { isFacilitiesFinished: true };
      case "ProductsAdmin":
        return { isProductsFinished: true };
      case "FacilityUsersAdmin":
        return { isFacilityUsersFinished: true };
      default:
        throw new Error("Invalid value");
    }
  };

  return useMutation<string, Error>({
    mutationFn: async () => {
      const payload = getPayload();
      return put<WalkthroughPayload, string>(
        `/api/user-walkthrough`,
        payload,
        false
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["walkthrough-tracker"] });
    },
  });
};
